import { Box, styled } from '@mui/material';

export const SmallBannerWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: '8px',
  padding: '42px 0px',
  background: theme.palette.themeLightColor?.main,
}));

export const getMargin = (applyMargin: boolean, theme: any) => ({
  margin: applyMargin ? '3rem 8rem 1rem' : null,
  [theme.breakpoints.down('lg')]: {
    margin: applyMargin ? '2rem 4rem 1rem' : null,
  },
  [theme.breakpoints.down('md')]: {
    margin: applyMargin ? '2rem 2rem 1rem' : null,
    textAlign: 'center',
  },
  [theme.breakpoints.up('xl')]: {
    width: '1300px',
    marginInline: 'auto !important',
  },
});
